<template>
  <div class="slider-overlay" v-if="visible">
    <div class="slider-dialog">
      <!-- <div class="slider-title">
        {{ title }}
      </div> -->
      <div class="slider-verification" ref="sliderContainer">
        <!-- 验证码容器 -->
        <div id="captcha-box"></div>
        <!-- 加载状态 -->
        <div class="loading" v-if="loading">
          加载中...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UrlConfig from '@/api/base-url.js';
export default {
  name: 'SliderVerification',
  props: {
    // 是否显示验证码
    visible: {
      type: Boolean,
      default: false
    },
    // 验证码标题
    title: {
      type: String,
      default: '安全验证'
    },
    // 验证码资源路径
    captchaUrl: {
      type: String,
      default: '/static/tac/js'
    }
  },
  data() {
    return {
      loading: false,
      tac: null,
      requestCaptchaDataUrl:'',//生成验证码的接口
      validCaptchaUrl:'',//验证验证码的接口
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.initCaptcha()
          })
        } else {
          this.destroyCaptcha()
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    // 初始化验证码
    initCaptcha() {
      let baseUrl=UrlConfig.baseUrl;
      this.requestCaptchaDataUrl=baseUrl+"/request/user/gen"
      this.validCaptchaUrl=baseUrl+"/request/user/check"

      this.loading = true

      // 检查是否已经加载了 loadTAC 函数
      if (window.loadTAC) {
        this.loadCaptcha()
      } else {
        // 动态加载 captcha.min.js
        this.loadCaptchaScript()
      }
    },

    // 动态加载验证码脚本
    loadCaptchaScript() {
      const script = document.createElement('script')
      script.src = `${this.captchaUrl}/captcha.min.js`
      script.onload = () => {
        this.loadCaptcha()
      }
      script.onerror = () => {
        this.loading = false
        this.$emit('error')
      }
      document.head.appendChild(script)
    },

    // 加载验证码
    loadCaptcha() {
      // 验证码配置
      const captchaConfig = {
        requestCaptchaDataUrl: this.requestCaptchaDataUrl,
        validCaptchaUrl: this.validCaptchaUrl,
        bindEl: "#captcha-box",
        validSuccess: (res, c, t) => {
          this.loading = false
          t.destroyWindow()
          this.$emit('success', res.data)
        },
        validFail: (res, c, t) => {
          this.loading = false
          t.reloadCaptcha()
          this.$emit('failed', res.msg)
        },
        btnRefreshFun: (el, tac) => {
          tac.reloadCaptcha()
        },
        btnCloseFun: (el, tac) => {
          tac.destroyWindow()
          this.$emit('close')
        }
      }
      //样式配置
      const style = {}

      window.loadTAC('/static/tac', captchaConfig, style).then(tac => {
        this.tac = tac
        this.loading = false
        tac.init()
      }).catch(e => {
        this.loading = false
        this.$emit('error', e)
      })
    },

    // 销毁验证码
    destroyCaptcha() {
      if (this.tac && this.tac.destroyWindow) {
        this.tac.destroyWindow()
        this.tac = null
      }
    },

    // 刷新验证码
    refreshCaptcha() {
      if (this.tac && this.tac.reloadCaptcha) {
        this.tac.reloadCaptcha()
      }
    }
  },
  beforeDestroy() {
    this.destroyCaptcha()
  }
}
</script>

<style scoped>
.slider-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.slider-dialog {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.slider-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-align: center;
  margin-bottom: 15px;
}

.slider-verification {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

#captcha-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;

}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  color: #666;
  font-size: 14px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .slider-verification {
    max-width: 280px;
  }
}
</style>
<style>
#tianai-captcha-parent .slider-bottom .refresh-btn{
  background-image: url('/static/tac/images/icon.png') !important;
}
#tianai-captcha-parent .slider-bottom.close-btn {
  background-image: url('/static/tac/images/icon.png') !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SliderVerification.vue